module.exports = __webpack_public_path__ + "img/linkedin.537a5166.png";